/***********************************
Menu Module
************************************/

Quad.Resources = ( function() {


  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    /* Get the grey filter's height to align with the ever-changing height of the search results */

    function filterMatchHeight() {
      var resultHeight = $( '#filter-match' ).height();
      $( '#filter' ).css( 'min-height', resultHeight );
    }
    $( document ).ready( function() {
      filterMatchHeight();
    });
    $( window ) .resize( function() {
      filterMatchHeight();
    });


    /*
    *
    * NOTES: In the WP API, multi post type search is fed through array, categories are simple comma-separated strings
    *
    * Global search settings, offset pagination, etc.
    *
    */


    var topics = [], allTopics, medias = [], allMedia;

    $( 'input[name="topic[]"]' ).each( function( i ) {
      topics[ i ] = $( this ).val();
    });
    allTopics = topics.join( ', ' );

    $( 'input[name="media[]"]' ).each( function( i ) {
      medias[ i ] = $( this ).val();
    });
    allMedia = JSON.stringify( medias );

    function getAllMedia() {
      var medias = [], allMedia;
      $( 'input[name="media[]"]' ).each( function( i ) {
        medias[ i ] = $( this ).val();
      });
      return JSON.stringify( allMedia );
    }

    var offset = 0;


    /* Input query logic */


    $( '.resource-main-search' ).submit( function( e ) {
      e.preventDefault();
      var query = $( '.resource-main-search input' ).val();
      var topic = [];
      $( 'input[name="topic[]"]:checkbox:checked' ).each( function( i ) {
        topic[ i ] = $( this ).val();
      });
      topic = topic.toString();
      topic = topic.replace( /,/g, ', ' );
      var topics = [];
      $( 'input[name="topic[]"]' ).each( function( i ) {
        topics[ i ] = $( this ).val();
      });
      var allTopics = topics.toString();
      allTopics = allTopics.replace( /,/g, ', ' );
      var mediaType = [];
      $( 'input[name="media[]"]:checkbox:checked' ).each( function( i ) {
        mediaType[ i ] = $( this ).val();
      });
      JSON.stringify( mediaType );
      var medias = [];
      $( 'input[name="media[]"]' ).each( function( i ) {
        medias[ i ] = $( this ).val();
      });
      JSON.stringify( medias );
      topic.length === 0 ? topic = allTopics : topic;
      mediaType.length === 0 ? mediaType = medias : mediaType;

      offset = 0;

      if( $('body').hasClass('page-template-resources') ){

        search( 0, mediaType, topic, query, false );

      }

    });


    /* Load More business logic */


    $( '.pagination button' ).click( function() {

      var query = $( '.resource-main-search input' ).val();
      var topic = [];
      $( 'input[name="topic[]"]:checkbox:checked' ).each( function( i ) {
        topic[ i ] = $( this ).val();
      });
      topic = topic.toString();
      topic = topic.replace( /,/g, ', ' );
      var topics = [];
      $( 'input[name="topic[]"]' ).each( function( i ) {
        topics[ i ] = $( this ).val();
      });
      var allTopics = topics.toString();
      allTopics = allTopics.replace( /,/g, ', ' );
      var mediaType = [];
      $( 'input[name="media[]"]:checkbox:checked' ).each( function( i ) {
        mediaType[ i ] = $( this ).val();
      });
      JSON.stringify( mediaType );
      var medias = [];
      $( 'input[name="media[]"]' ).each( function( i ) {
        medias[ i ] = $( this ).val();
      });
      JSON.stringify( medias );

      topic.length === 0 ? topic = allTopics : topic;
      mediaType.length === 0 ? mediaType = medias : mediaType;

      $( this ).addClass( 'loading' );

      // TODO: Offset keeps racking up, but it should be reset with fresh queries

      offset += 12;

      //offset,type,topic,query,isLoadMore

      if( $('body').hasClass('page-template-resources') ){
        
        search( offset, mediaType, topic, query, true );

      }

    });

    /* Checkboxes, part 1: Parsing query strings if applicable */

    if ( typeof type_filter === 'object' && type_filter.length !== null ) {
      var typeLength = type_filter.length;
      for ( var i = 0; i < typeLength; i++ ) {
        $( '.resource-filter[value="'+ type_filter[ i ] +'"]' ).parent().addClass( 'checked' );
        $( '.resource-filter[value="'+ type_filter[ i ] +'"]' ).prop( 'checked', true );
      }
    }
    if ( typeof cat_filter === 'object' && cat_filter.length !== null ) {
      var catLength = cat_filter.length;
      for ( var i = 0; i < catLength; i++ ) {
        $( '.resource-filter[value="'+ cat_filter[ i ] +'"]' ).parent().addClass( 'checked' );
        $( '.resource-filter[value="'+ cat_filter[ i ] +'"]' ).prop( 'checked', true );
      }
    }

    /* Checkbox business logic */

    $( '.icheckbox' ).on( 'ifToggled', function( event ) {

      $( this ).hasClass( 'checked' ) ? $( this ).children( '.resource-filter' ).prop( 'checked', false ) : $( this ).children( '.resource-filter' ).prop( 'checked', true );

      var query = $( '.resource-main-search input' ).val();

      var topic = [];
      $( 'input[name="topic[]"]:checkbox:checked' ).each( function( i ) {
        topic[ i ] = $( this ).val();
      });
      topic = topic.toString();
      topic = topic.replace( /,/g, ', ' );

      var topics = [];
      $( 'input[name="topic[]"]' ).each( function( i ) {
        topics[ i ] = $( this ).val();
      });

      // All topics, grabbing from each topic
      // NOTE: If we want the filter to be SPECIFICALLY topics A, B, and C, we use + instead of commas

      var allTopics = topics.toString();
      allTopics = allTopics.replace( /,/g, ', ' );

      // If topics have been checked, show those, if not, show all of them

      topic.length === 0 ? topic = allTopics : topic;

      var mediaType = [];
      $( 'input[name="media[]"]:checkbox:checked' ).each( function( i ) {
        mediaType[ i ] = $( this ).val();
      });

      JSON.stringify( mediaType );

      var medias = [];
      $( 'input[name="media[]"]' ).each( function( i ) {
        medias[ i ] = $( this ).val();
      });

      JSON.stringify( medias );

      mediaType.length === 0 ? mediaType = medias : mediaType;

      // NOTE: TOPICS = category_name STRING, TYPES = post_type ARRAY

      offset = 0;

      if( $('body').hasClass('page-template-resources') ){

        search( 0, mediaType, topic, query, false );

      }

    });


    /* Search reset business logic */


    $( '.clear-posts' ).click( function() {

      $( '.icheckbox' ).removeClass( 'checked' );
      $( '.icheckbox .resource-filter' ).prop( 'checked', false );

      offset = 0;

      if( $('body').hasClass('page-template-resources') ){
        
        search( 0, medias, allTopics, null, false );

      }

    });

    /* SEARCH - The meat and potato function */

    function search( offset, type, topic, query, isLoadMore ) {

      isLoadMore ? '' : $( '.results .result' ).remove();

      var path = window.location.href.split( '/' );
      path = path[ 0 ]+'//'+path[ 2 ];
      
      console.log(type);

      $.ajax({

        method: 'POST',
        url: path + '/wp-admin/admin-ajax.php',
        data: {

          offset: offset,
          type: type, // Array, JSON.stringified
          topic: topic, // String, comma delimited
          query: query,
          action: 'sort_posts'

        },
        success: function( response ) {

          console.log( 'RESOURCE response:' );
          console.dir( response );

          $( '.pagination button' ).removeClass( 'loading' );

          var posts = response.data.posts;

          if ( posts.length > 0 ) {

            for ( var i = 0; i < posts.length; i++ ) {

              var cta;

              if ( posts[ i ].type === 'post' ) {
                cta = 'Read the post';
              } else if ( posts[ i ].type === 'document' ) {
                cta = 'View the doc';
              } else if ( posts[ i ].type === 'tech_spec' ) {
                cta = 'View the tech spec';
              } else if ( posts[ i ].type === 'video' ) {
                cta = 'Watch the video';
              } else if ( posts[ i ].type === 'news' ) {
                cta = 'Read the story';
              } else if ( posts[ i ].type === 'case_study' ) {
                cta = 'View the case study';
              }

              $( '.results' ).append(

                '<div class="post tile result '+ ( posts[ i ].img ? 'with-bg' : '' ) +'" style="background-image:url('+ ( posts[ i ].img ? posts[ i ].img : '/wp-content/themes/quad/assets/images/global/resource-default-bg.png' ) +');">'+
                '<div>'+
                '<span>'+ posts[ i ].date +'</span>'+
                '<h4>'+ posts[ i ].title +'</h4>'+
                '<a class="btn post" href="'+ posts[ i ].href +'">'+ cta +'</a>'+
                '</div>'+
                '</div>'

                );

                $( '.result' ).equalHeight();

                $( '.tile a' ).hover( function() {
                  $( this ).parents( '.tile' ).addClass( 'hover' );
                }, function() {
                  $( this ).parents( '.tile' ).removeClass( 'hover' );
                });

              }

            } else {

              $( '.results' ).append( '<span class="result no-results">Sorry - No results matched this query.</span>' );

            }

            filterMatchHeight();

            var grandTotal;

            posts.length > 0 ? grandTotal = posts[ 0 ].grand_total : grandTotal = 0;

            grandTotal <= 12 || grandTotal - posts[ 0 ].offset <= 12 ? $( '#load-more' ).addClass( 'hidden' ) : $( '#load-more' ).removeClass( 'hidden' );

            if ( isLoadMore ) {

              var currentInt = $( '.current-count' ).text();
              currentInt = parseInt( currentInt );
              $( '.current-count' ).text( currentInt += posts.length );

            } else {

              $( '.current-count' ).text( posts.length > 12 ? 12 : posts.length );
              $( '.total' ).text( grandTotal );

            }

          },

          error: function( response ) {
            console.log( 'Error.' );
          }

        });

      }

    }


    // PUBLIC METHODS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~
    return {

      init: _init

    };

  })();

